const subscribers = {};

function subscribe(eventName, callback) {
  if (!subscribers[eventName]) {
    subscribers[eventName] = [];
  }

  const index = subscribers[eventName].push(callback) - 1;

  return () => {
    subscribers[eventName].splice(index, 1);
  };
}

function publish(eventName, data) {
  if (!subscribers[eventName]) {
    return Promise.resolve();
  }

  return subscribers[eventName].reduce((promise, callback) => {
    return promise.then(() => {
      return callback(data);
    });
  }, Promise.resolve());
}

